// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.13314"][{"9696":0}[chunkId]] || "1.13315") + "/" + chunkId + ".js";
};